"use client"
/* */
import 'invariant';
import 'luxon';
import 'react/jsx-runtime';
import 'react-aria-components';
import 'react';
import 'clsx';
import '../../../../lib/propsContext/propsContext.mjs';
import '../../../../lib/viewComponentContext/viewComponentContext.mjs';
import '@mittwald/react-tunnel';
import '../../../../lib/slotContext/slotContext.mjs';
import '@react-aria/utils';
import 'remeda';
import 'dot-prop';
import '@tabler/icons-react';
import '../../../Icon/Icon.mjs';
import '../../../Heading/Heading.mjs';
import '../../../Text/Text.mjs';
import 'react-aria';
import '../../../Button/Button.mjs';
import '../../../ContextMenu/ContextMenu.mjs';
import '../../../MenuItem/MenuItem.mjs';
import '../../../ContextMenu/components/ContextMenuTrigger/ContextMenuTrigger.mjs';
import '../../../ContextMenu/components/ContextMenuSection/ContextMenuSection.mjs';
import '../../../ColumnLayout/ColumnLayout.mjs';
import '../ListSummary/ListSummary.mjs';
import { useList } from '../../hooks/useList.mjs';
import '../../List.mjs';

const useAvailableViewModes = () => {
  const list = useList();
  const availableViewModes = [];
  if (list.itemView?.showList) {
    availableViewModes.push("list");
  }
  if (list.table) {
    availableViewModes.push("table");
  }
  if (list.itemView?.showTiles) {
    availableViewModes.push("tiles");
  }
  return availableViewModes;
};

export { useAvailableViewModes };
//# sourceMappingURL=lib.mjs.map
